import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32f5eab6&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=32f5eab6&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5eab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f5eab6')) {
      api.createRecord('32f5eab6', component.options)
    } else {
      api.reload('32f5eab6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32f5eab6&scoped=true&", function () {
      api.rerender('32f5eab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setUp/index.vue"
export default component.exports